import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5964031e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = {
  key: 0,
  class: "protein-settings"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" mRNA(s):")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed, ref } from "vue";
import { useStore } from "@/store";
import ListBox from "@/components/ListBox.vue";
import Logger from "./Logger.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

const store = useStore();

const measurableProteins = ["matter.visiMCherry.name", "matter.visiGFP.name"];

const proteinNames = computed(() =>
  store.proteins.map((protein) => protein.displayName)
);
const activeProteinDisplayName = ref("");
const activeProtein = computed(() => {
  if (activeProteinDisplayName.value === "") return null;
  const protein = store.proteins.filter(
    (protein) => protein.displayName === activeProteinDisplayName.value
  );
  if (protein.length !== 1) {
    // throw new Error(`Protein: ${activeProteinName.value} does not exist or duplicates.`)
    return null;
  }
  return protein[0];
});
const activeProteinName = computed(() => activeProtein.value?.name ?? "");
const activeProteinMessengerRNAs = computed(() => {
  if (activeProtein.value === null) return [];
  return activeProtein.value.messengerRNAs.map((mRNA) =>
    mRNA.getDisplayName(t)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListBox, {
      list: _unref(proteinNames),
      modelValue: activeProteinDisplayName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeProteinDisplayName).value = $event)),
      class: "protein-list"
    }, null, 8, ["list", "modelValue"]),
    (_unref(activeProtein))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(_unref(t)(activeProteinDisplayName.value)), 1),
          _createTextVNode(" " + _toDisplayString(_unref(t)(_unref(activeProtein).description)), 1),
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createVNode(ListBox, {
            list: _unref(activeProteinMessengerRNAs),
            localized: ""
          }, null, 8, ["list"]),
          (measurableProteins.includes(activeProteinDisplayName.value))
            ? (_openBlock(), _createBlock(Logger, {
                key: 0,
                target: _unref(activeProteinName)
              }, null, 8, ["target"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})